// extracted by mini-css-extract-plugin
export default {"container":"eVSLJHcWEaaTWjirg9uW","overlay":"rw6sobLOyBgN5xxLiWfV","fixed":"Uf4FKKxWaG6ykofklRTw","bounce":"DseShZyopREXw98GsxOg"};